'use client';

import { useEffect, useState } from 'react';
import { Button } from '@/components/atoms/Button/Button';
import { Image } from '@/components/atoms/Image/Image';
import { events } from '@/utils/events';
import { allowPageScroll, blockPageScroll } from '@/utils/storeSetters';
import * as Styled from './ModalVirtualTour.styled';

export interface IModalVirtualTourProps {
  tourUrl: string;
}

export const ModalVirtualTour: React.FC<IModalVirtualTourProps> = ({
  tourUrl,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener(events.toggleVirtualTourModal, () => {
        setIsOpen(true);
      });
      return () => {
        window.removeEventListener(events.toggleVirtualTourModal, () => {
          setIsOpen((prev) => !prev);
        });
      };
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      blockPageScroll();
    } else {
      allowPageScroll();
    }
  }, [isOpen]);

  return (
    <Styled.VirtualTourModalContainer data-is-open={isOpen}>
      <Button
        className={'close-btn'}
        scaleOnHover={true}
        callbackOnClick={() => setIsOpen(false)}
      >
        <Image
          src="/img/icons/cross.svg"
          alt="close images gallery"
          height={35}
          width={35}
          fill={false}
        />
      </Button>

      <iframe src={tourUrl} />
    </Styled.VirtualTourModalContainer>
  );
};
